<template>
  <ion-page>
    <master-layout pageTitle="ثبت نام در سیستم">
      <br/>
      <ion-img src="/assets/img/logo-land.png" class="login-img"></ion-img>
      <ion-card v-if="!confirmCode && !sendCode">
        <ion-card-content>
          <div class="form-group">
            <label>شماره تلفن</label>
            <input placeholder="شماره تلفن خود را وارد کنید" type="tel" name="phone" v-model="phone" class="form-control">
          </div>
          <ion-button @click="getRegisterCode()" color="success" expand="full">تایید و ارسال کد</ion-button>
        </ion-card-content>
      </ion-card>
      <ion-card v-if="!confirmCode && sendCode">
        <ion-card-content>
          <div>
          برای ساخت حساب جدید، کد تایید برای  شماره
          {{phone}}
          ارسال گردید.
          </div>
          <div class="form-group">
            <label>کد تایید را وارد نمایید </label>
            <input v-model="code" type="tel" name="code" class="form-control">
          </div>
          <ion-button @click="submitRegisterCode()" color="danger" expand="full">تایید و ادامه</ion-button>
          <div>
           مدت زمان باقی مانده برای تایید کد :
          <timer class="text-danger" v-if="expireTime" :number="expireTime"></timer>
          </div>
        </ion-card-content>
      </ion-card>
      <ion-card v-if="confirmCode">
        <ion-card-content>
          <ajax-form route="app/RegisterAutoService" :callback="registerCallback">
          <div class="form-group">
            <label class="required">نام اتوسرویس</label>
            <input type="text" name="title" class="form-control">
          </div>
          <div class="form-group">
            <label class="required">نام کامل مدیر</label>
            <input type="text" name="fullname" class="form-control">
          </div>
          <div class="form-group">
            <label class="required">کد ملی</label>
            <input type="tel" name="national_code" class="form-control">
          </div>
          <div class="form-group">
            <label class="required">تلفن همراه</label>
            <input type="tel" readonly :value="phone" name="phone" class="form-control">
          </div>
            <div class="form-group">
              <label>کد پستی</label>
              <input type="tel"   name="postal_code" class="form-control">
            </div>
          <div class="form-group">
            <label>تلفن ثابت</label>
            <input type="tel" name="telephone" class="form-control">
          </div>
          <div class="form-group">
            <label class="required">نام کاربری</label>
            <input type="text" v-model="username" name="username" class="form-control">
          </div>
          <div class="form-group">
            <label class="required">کلمه عبور</label>
            <input type="password" v-model="password" name="password" class="form-control">
          </div>
          <div class="form-group">
            <label class="required">آدرس</label>
            <textarea name="address" class="form-control"></textarea>
          </div>
          <div class="mt-2">
            <label>موقعیت روی نقشه</label>
            <div id="map"></div>
            <input type="text" name="lat" v-model="lat" hidden id="lat"  />
            <input type="text" name="lng" v-model="lng" hidden id="lng" />
            <input type="text" name="zoom" hidden id="zoom" value="" />
          </div>
            <ion-button type="submit" expand="full" color="success">ثبت اطلاعات</ion-button>
          </ajax-form>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>


<script>

import {
  IonCard, IonCardContent, IonPage,
} from "@ionic/vue";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
require('leaflet.locatecontrol')
import {mapGetters, mapActions} from "vuex";
import {useRouter} from 'vue-router';
import {showSystemNoti} from '@/shared/helper'
import Timer from "@/components/Timer";
import AjaxForm from "@/components/AjaxForm";

export default {
  components: {
    AjaxForm,
    Timer,
    IonCard, IonCardContent, IonPage
  },
  data()
  {
    return {
      confirmCode : false,
      sendCode : false,
      expireTime : false,
      phone : '',
      code : '',
      map:null,
      markerHolder:null,
      username:'',
      lat : '',
      lng : '',
      password:''
    };
  },
  mounted()
  {
    this.init();
  },
  computed: {
    ...mapGetters("auth", {
      loginStatus: "getLoginStatus",
    }),
  },
  setup()
  {
    const router = useRouter();
    return {router};
  },
  methods: {
    async registerCallback(data)
    {
      if (!data.ok)
      {
        showSystemNoti('danger',data.error);
        return;
      }
      showSystemNoti('success','ثبت نام شما با موفقیت انجام شد. درحال انتقال ...');
      await this.loginUser({
        username:this.username,
        password:this.password
      });
      if (this.loginStatus === "success")
      {
        setTimeout(function ()
        {
          window.location.replace('/')
        }, 500)
      }
      else
      {
        this.$router.replace({path:'Login'})
      }
    },
    init()
    {
      // setTimeout(()=>{
      //   this.initMap();
      // },250)
    },
    initMap()
    {
      const lat = 36.314571865811935, lng = 59.57267761230469;
      const zoom = 12;
      const osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          osmAttrib = '&copy; <a href="https://carencar.com">کارن کار</a>',
          osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
      this.map = L.map('map', {
        zoomControl: true,
        dragging: true,
        boxZoom: true,
        scrollWheelZoom: true
      }).setView([lat, lng], zoom).addLayer(osm);

      L.control.locate({
        drawCircle: true, // controls whether a circle is drawn that shows the uncertainty about the location
        setView: true, // automatically sets the map view to the user's location, enabled if follow is true
        follow:true,
        flyTo:true,
        keepCurrentZoomLevel: false, // keep the current map zoom level when displaying the user's location. (if false, use maxZoom)
        circlePadding: [0, 0], // padding around accuracy circle, value is passed to setBounds
        locateOptions: {
          maxZoom: 15
        },
        strings: {
          title: "نمایش موقعیت فعلی",
          popup: "موقعیت فعلی شما",
          outsideMapBoundsMsg: "بنظر میاد شما در خارج از این کره خاکی هستید",
        }
      }).addTo(this.map);

      this.map.on('click',(e) =>{
        this.placeMarker(e);
      });

      this.map.once('locationfound ',(e)=>{
        this.placeMarker(e);
      })

    },
    placeMarker(e)
    {
      try
      {
        if (this.markerHolder)
          this.markerHolder.removeFrom(this.map);
      } catch (e)
      {
        console.log(e);
      }

      const markerIcon = new L.Icon({
          iconUrl: '/assets/img/map-marker.png',
          iconSize:     [30, 30],
      });
      this.markerHolder = new L.marker(e.latlng,{icon:markerIcon})
      this.markerHolder.addTo(this.map);
      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;

    },
    async getRegisterCode()
    {
      const check = await this.getRegisterCodeFunc(this.phone);
      if (check.ok)
      {
        this.expireTime = check.expire_time;
        this.sendCode = true;
      }
      else
        showSystemNoti('danger',check.error);
    },
    async submitRegisterCode()
    {
      const phone = this.phone;
      const code = this.code;
      const check = await this.submitRegisterCodeFunc({phone,code})
      if (check.ok)
      {
        this.confirmCode = true;
        this.sendCode = true;
        this.code = '';
        setTimeout(()=>{
          this.initMap();
        },250)
      }
      else
        return showSystemNoti('danger',check.error);
    },
    ...mapActions("auth", {
      loginUser: "loginUser",
    }),
    ...mapActions("app",{
      getRegisterCodeFunc : 'getRegisterCode',
      submitRegisterCodeFunc : 'submitRegisterCode'
    }),
  },
};
</script>

<style scoped>
.login-img {
  max-width: 100%;
  width: 100px;
  margin: 0 auto;
}
#map{
  height: 400px;
  direction: ltr;
}
</style>